export default {
    notifications: {
        getList: ['GET', 'notifications'],
        update: ['PATCH', 'notifications'],
    },
};
